import { Share2, Link2, MessageCircle, Facebook } from "lucide-react";
import { toast } from "sonner";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const ShareButton = ({ spot }) => {
  const url = `${window.location.origin}/spots/${spot.id}`;
  const text = `Viens pêcher avec moi à ${spot.name} (${spot.department}) !`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Lien copié !");
    } catch {
      toast.error("Impossible de copier le lien");
    }
  };

  const open = (href) => window.open(href, "_blank", "noopener,noreferrer");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="share-spot-btn"
          className="flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur text-emerald-900 font-semibold px-4 py-2 text-sm transition-transform duration-200 hover:scale-105"
        >
          <Share2 className="w-4 h-4" /> Partager
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="z-[1000]">
        <DropdownMenuItem data-testid="share-copy-link" onClick={copy}>
          <Link2 className="w-4 h-4 mr-2" /> Copier le lien
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="share-whatsapp"
          onClick={() => open(`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`)}
        >
          <MessageCircle className="w-4 h-4 mr-2 text-green-600" /> WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem
          data-testid="share-facebook"
          onClick={() => open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`)}
        >
          <Facebook className="w-4 h-4 mr-2 text-blue-600" /> Facebook
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
